export const LOCATION_PERMISSIONS_SUCCESS = '@solv-ios/location_permissions_success';
export const LOCATION_PERMISSIONS_FAIL = '@solv-ios/location_permissions_fail';
